module.exports = __webpack_public_path__ + "static/media/Downhill Skier.b37d33ac.jpg";